import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
	selector: 'copo-submit-dialog',
	templateUrl: './submit-dialog.component.html',
	styleUrl: './submit-dialog.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [MatProgressSpinnerModule, MatDialogModule]
})
export class SubmitDialogComponent {
	progressMessage: string | undefined;
	waitMessage: string | undefined;
}
